module.exports = "# Контакты\n\n### Омский офис\n**Адрес:**<br>\nРоссия, 644043<br>\nг. Омск<br>\nул. Певцова 7, этаж 3\n\n**Телефоны:**<br>\n(3812) 21-00-42, 24-54-12, 24-63-16<br>\nПроезд до остановки «Кинотеатр им. Маяковского»\n\n**Электронная почта:**<br>\npp@lab321.ru - общий адрес для группы компаний 321<br>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/pages_content/contacts.md
// module id = 4kBn
// module chunks = 1